<template>
  <nav
    v-if="breadcrumbs.length > 0"
    class="text-sm text-gray-600 mb-10">
    <ol class="list-reset flex">
      <li>
        <a
          :href="companyHomeUrl"
          class="text-blue-600 hover:underline">
          {{ companyTitle }}
        </a>
        <span class="mx-2">/</span>
      </li>
      <li>
        <router-link
          to="/"
          class="text-blue-600 hover:underline">
          {{ props.startPageName || 'Home' }}
        </router-link>
        <span class="mx-2">/</span>
      </li>
      <li
        v-for="(breadcrumb, index) in breadcrumbs"
        :key="index">
        <router-link
          v-if="breadcrumb.path !== $route.path"
          :to="breadcrumb.path"
          class="text-blue-600 hover:underline">
          {{ breadcrumb.breadcrumb }}
        </router-link>
        <span v-else>{{ breadcrumb.breadcrumb }}</span>
        <span
          v-if="index < breadcrumbs.length - 1"
          class="mx-2"
          >/</span
        >
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const props = defineProps<{
  startPageName?: string;
}>();

const companyTitle = CURRENT_COMPANY_TITLE;
const companyHomeUrl = COMPANY_BASE_URL;

const breadcrumbs = computed(() => {
  if (route.path === '/') {
    return [];
  }

  const result = [];

  let current = route.matched.at(-1);
  while (current) {
    const { breadcrumb, parent } = current.meta || {};
    if (breadcrumb) {
      result.unshift({
        breadcrumb: typeof breadcrumb === 'function' ? breadcrumb(route) : breadcrumb,
        path: current.path,
      });
    }
    current = parent ? router.getRoutes().find((r) => r.path === parent) : null;
  }

  return result;
});
</script>
